import {
	PlainBackgroundType,
	PlainFontFamily,
	PlainReservationComponentType,
	PlainSizeType,
	PlainWidgetDecoration,
} from "@/lib/gql/__generated__/graphql";

export const DEFAULT_VALUES = {
	// 基本設定
	// 色の設定
	// 背景色の設定
	colorBackground: "#ffffff",
	// テーマカラーの設定
	colorPrimary: "#444444",
	// 文字色の設定
	colorFont: "#000000",
	// 施設情報の表示・非表示
	// ホテルロゴのサイズ
	logoSize: PlainSizeType.Medium,
	// フォント設定
	fontFamily: PlainFontFamily.NotoSansJp,
	// 予約パーツの設定
	reservationComponentType: PlainReservationComponentType.Inline,
	// スナック
	// スナックの追加
	widgetDecoration: PlainWidgetDecoration.None,

	//
	backgroundType: PlainBackgroundType.Color,
};
